import clsx from "clsx";
import styles from "./styles.module.scss";

interface EndNotesProps {
  heading?: string;
  tag?: "h2" | "h3";
  isDarkBG?: boolean;
  mode?: "collapsed" | "no-heading" | "heading";
}

export function EndNotes({
  heading,
  tag: Tag = "h2",
  isDarkBG,
  children,
  mode,
}: React.PropsWithChildren<EndNotesProps>) {
  return (
    <div className={clsx(styles.container, isDarkBG && styles["dark-bg"])}>
      {mode == "collapsed" && (
        <details className={styles.details}>
          <summary className={styles.summary}>
            <Tag className={styles.heading}>{heading || "Notes"}</Tag>
            <svg className={styles["svg-plus"]} viewBox="0 0 20 20" fill="none">
              <rect
                className={styles.horiz}
                x="9"
                y="5"
                width="1.5"
                height="10"
                fill="currentColor"
              />
              <rect
                x="15"
                y="9"
                width="1.5"
                height="10"
                transform="rotate(90 15 9)"
                fill="currentColor"
              />
            </svg>
          </summary>
          {children}
        </details>
      )}

      {mode !== "collapsed" && (
        <div>
          {mode == "heading" && (
            <Tag className={styles.heading}>{heading || "Notes"}</Tag>
          )}
          {children}
        </div>
      )}
    </div>
  );
}
